import React, { useState, useEffect, useRef } from "react";
import "../../App.css";


function ProductsLandingPage({ handleNavClick }) {
  return (
    <div className="products-landing-page">
      {/* Products Header with Overall Background */}
      <div className="products-header">
        <div className="section__container">
          <h2 className="section__title">Our Products</h2>
          {/*<p className="section__intro">
            Explore our wide range of geospatial software, hardware, and data products designed for diverse industries.
          </p>*/}
        </div>
      </div>
      {/* Products Grid */}
      <div className="products_bg">
        <section className="section-product-page">
          <div className="section__container">
            <h3 className="products-landing__title">What We Offer</h3>
            <p className="products-landing-discription">
              Our offerings are distinguished by an unwavering commitment to quality, innovation, and customer satisfaction.
            </p>
            <div className="products-grid">
              {/* ESRI Software */}
              <div className="product-card" onClick={() => handleNavClick("software-products")}>
                <div className="product-header-bg esri-bg">
                  <h4 className="product-card__title"></h4>
                </div>
                <div className="card-divider"></div>
                <p className="product-card__description">
                  Find industry-leading software for GIS, data visualization, remote sensing, and more.
                </p>
                <button className="read-more">Read More</button>
              </div>
              {/* Idea Forge */}
              <div className="product-card" onClick={() => handleNavClick("hardware-products")}>
                <div className="product-header-bg idea-bg">
                  <h4 className="product-card__title"></h4>
                </div>
                <div className="card-divider"></div>
                <p className="product-card__description">
                  Discover cutting-edge hardware, including drones, UAVs, and underwater vehicles.
                </p>
                <button className="read-more">Read More</button>
              </div>
              {/* Planet Satellite */}
              <div className="product-card" onClick={() => handleNavClick("maps-data-products")}>
                <div className="product-header-bg planet-bg">
                  <h4 className="product-card__title"></h4>
                </div>
                <div className="card-divider"></div>
                <p className="product-card__description">
                  Access high-resolution satellite imagery, topographic maps, and other essential geospatial data.
                </p>
                <button className="read-more">Read More</button>
              </div>
              {/* Here Maps */}
              <div className="product-card" onClick={() => handleNavClick("heremaps")}>
                <div className="product-header-bg here-bg">
                  <h4 className="product-card__title"></h4>
                </div>
                <div className="card-divider"></div>
                <p className="product-card__description">
                  Access high-resolution satellite imagery, topographic maps, and other essential geospatial data.
                </p>
                <button className="read-more">Read More</button>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
}

export default ProductsLandingPage;